import { Layers } from 'lucide-react'
import { useState } from 'react'

import FilterManagementDropdown from 'components/brokers/needs_attention/FilterManagementDropdown'
import { filterByLabelAndValueCallback } from 'components/brokers/needs_attention/utils'
import { type MultipleSelectedValuesFilter } from 'components/brokers/types'
import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from 'components/reusable/table/ComboboxMultiSelectFilter'
import { MemberOnboardingMedicalPlanMetalTier } from 'utils/web_api.schemas'

const METAL_TIER_OPTIONS: ComboboxFilterOption<string>[] = Object.entries(MemberOnboardingMedicalPlanMetalTier).map(([key, value]) => ({
  label: key.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '),
  value,
}))

const MetalTierFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const filteredOptions = METAL_TIER_OPTIONS.filter(
    filterByLabelAndValueCallback(query)
  )

  // Ensure selectedValues is always an array
  const selectedValues = props.selectedValues || []

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        selectedValues={selectedValues}
        options={[
          { groupLabel: 'Metal tiers', options: filteredOptions },
        ]}
        placeholder='Search metal tiers to filter...'
        onValueChange={setQuery}
      >
        <button
          type='button'
          className='w-full'
          style={{ all: 'unset', cursor: 'pointer' }}
        >
          <FilterManagementDropdown
            {...props}
            selectedValues={selectedValues}
            options={METAL_TIER_OPTIONS}
            noSelectionText='Metal Tier'
            pluralIdentifier='metal tiers'
          >
            <Layers size={20} />
          </FilterManagementDropdown>
        </button>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default MetalTierFilter
